<ul nz-menu nzMode="inline" class="main-nav">
  <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menus }"></ng-container>

  <ng-template #menuTpl let-menus>
    <ng-container *ngFor="let menu of menus">
      <!-- LEAF MENU ITEM -->
      <li *ngIf="!menu.children" nz-menu-item nzMatchRouter [nzPaddingLeft]="menu.level * 24">
        <a class="menu-link" [routerLink]="menu.path" (click)="onMenuItemClick(menu)">
          <span class="menu-item-content">
            <i nz-icon *ngIf="menu.iconClass" [nzType]="menu.iconClass"></i>
            <span class="menu-text">{{ menu.name }}</span>
          </span>
        </a>
      </li>

      <!-- SUB MENU -->
      <li
        *ngIf="menu.children"
        nz-submenu
        [(nzOpen)]="menu.open"
        [nzPaddingLeft]="menu.level * 24"
        [nzTitle]="title"
      >
        <!-- Custom title -->
        <ng-template #title>
          <span class="menu-item-content">
            <i nz-icon *ngIf="menu.iconClass" [nzType]="menu.iconClass"></i>
            <span class="menu-text">{{ menu.name }}</span>
          </span>
        </ng-template>

        <ul [attr.data-index]="menu.order">
          <ng-container
            *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }"
          ></ng-container>
        </ul>
      </li>
    </ng-container>
  </ng-template>
</ul>

<div class="menu-bottom-spacer"></div>
